module.exports = new __parcel__URL__("Lego.71d26db9.jpeg").toString();